// Opening Balance State

export default {
  openingBalanceInfo: {}
}
